<template>
  <div class="fnds">
    <modal :title="title" v-if="modal" @close="switchModal">
      <fnd @close="switchModal" :data="editableFnd"/>
    </modal>
    <ccs-header
      title="ФНД"
      :info="false" nightTheme back/>
    <div class="fnds-content">
      <div class="fnds-actions">
        <nav-bar :dataFunction="getFnds" :orderFields="orderFields" nightTheme/>
        <button v-if="permissionsStatus.isFndCreateAllowed"
          class="ccs-button" @click="switchModal()">
          Добавить ФНД
        </button>
      </div>
      <ccs-table :data="fnds" :columnsDefs="columnsDefs" :options="tableOptions">
        <template v-slot:organization="props">
          {{ props.row.name || 'Отсутствует' }}
        </template>
        <template v-slot:actions="props">
          <v-icon v-if="permissionsStatus.isFndUpdateAllowed"
            class="ccs-icon--primary ccs-icon--hover" name="edit"
            @click="switchModal(props.row)"/>
          <v-icon v-if="permissionsStatus.isFndDeleteAllowed"
            class="ccs-icon--secondary ccs-icon--hover"
            name="trash" scale="0.9"
            @click="removeFnd(props.row)"/>
        </template>
      </ccs-table>
      <pagination :dataFunction="getFnds" nightTheme/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

import Fnd from '@/components/modals/fnds/Fnd.vue';
import { PermissionsList } from '@/helpers/permissions';

export default {
  name: 'Fnds',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    Modal,
    Fnd,
    NavBar,
    Pagination,
  },
  data() {
    return {
      PermissionsList,
      modal: false,
      editableFnd: null,
      titles: {
        new: 'Новое ФНД',
        edit: 'Редактирование ФНД',
        employeesEdit: 'Пользователи ФНД'
      },
      orderFields: [{
        prop: 'created_at',
        text: 'Дате создания',
      }, {
        prop: 'name',
        text: 'Названию',
      }],
      columnsDefs: [{
        name: `code`,
        title: 'Код',
        prop: 'code',
      }, {
        name: `name`,
        title: 'Название',
        prop: 'name',
      }, {
        name: `description`,
        title: 'Описание',
        prop: 'description',
      }, {
        name: `created_at`,
        title: 'Дата создания',
        prop: 'created_at',
        type: 'date',
      }, {
        name: `actions`,
        title: ``,
        prop: `id`,
        isActions: true,
      }],
      tableOptions: {
        hideBottomBorder: true,
        nightTheme: true,
      },
    };
  },
  computed: {
    ...mapState('fnd', ['fnds']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableFnd ? this.titles.edit : this.titles.new;
    },
  },
  methods: {
    ...mapActions('fnd', ['getFnds', 'deleteFnd']),
    switchModal(editableFnd = null) {
      this.modal = !this.modal;
      this.editableFnd = !editableFnd ? editableFnd : Object.assign({}, editableFnd);
    },
    startEditing(fnd) {
      this.switchModal();
      this.editableFnd = Object.assign({}, fnd);
    },
    async removeFnd(fnd) {
      try {
        await this.deleteFnd(fnd.id);
        this.$toasted.success('ФНД удалено');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fnds {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-content {
    margin: 0 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &-actions {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

}
</style>
